export const appVersion = '1.379.0-WEB-3967-fix-animation-color-customization-SNAPSHOT-1792395742';
export const commitHash = 'f86045de9';
